import { render, staticRenderFns } from "./ReferenceTabs.vue?vue&type=template&id=32ff5af8&scoped=true&"
import script from "./ReferenceTabs.vue?vue&type=script&lang=ts&"
export * from "./ReferenceTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceTabs.vue?vue&type=style&index=0&id=32ff5af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff5af8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabs})
